import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { LoanCard } from './card-lenses';

const Previous = ({ model, onChange, ...cardProps }) => (
  <Card
    title="Have you been issued a pre-approval letter from a lender in the last 30 days?"
    {...cardProps}
  >
    <BooleanRadioButtons
      name="previousPreapproval"
      value={model.get('previousPreapproval')}
      onChange={onChange.bind(null, 'previousPreapproval')}
    />
  </Card>
);

Previous.completed = ({ model }) => model.get('previousPreapproval') != null;

Previous.id = 'PreviousPreapproval';

export default LoanCard(Previous);



// WEBPACK FOOTER //
// ./src/cards/previous-preapproval.js